"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:deprecation
var TabStyles_1 = require("../styles/TabStyles");
var ClickBusting_1 = require("./ClickBusting");
var ScrollingRoot_1 = require("./ScrollingRoot");
var StackingRoot_1 = require("./StackingRoot");
var StyleMediaQueries_1 = require("./StyleMediaQueries");
var WidgetManager_1 = require("../utils/WidgetManager");
var setStyleMediaQueries = function (config) {
    if (!config.styleMediaQueries) {
        return;
    }
    StyleMediaQueries_1.StyleMediaQueryManager.setMediaStyleQueries(config.styleMediaQueries);
};
var setTabStyles = function (config) {
    if (!config.styles) {
        return;
    }
    TabStyles_1.overrideTabStyles(config.styles);
    WidgetManager_1.WidgetManager.rerenderWidgets();
};
var setStackingRoot = function (config) {
    if (!config.defaultStackingRootId) {
        return;
    }
    StackingRoot_1.StackingRootConfig.setDefaultRootContainerId(config.defaultStackingRootId);
};
var setScrollingRoot = function (config) {
    if (!config.defaultScrollingRootId) {
        return;
    }
    ScrollingRoot_1.ScrollingRootConfig.setDefaultRootContainerId(config.defaultScrollingRootId);
};
var setClickBusting = function (config) {
    if (!config.suppressClickBustingClassName) {
        return;
    }
    ClickBusting_1.ClickBustingConfig.suppressionClassName = config.suppressClickBustingClassName;
};
var setConfig = function (config) {
    setTabStyles(config);
    setStackingRoot(config);
    setScrollingRoot(config);
    setStyleMediaQueries(config);
    setClickBusting(config);
};
exports.setConfig = setConfig;
//# sourceMappingURL=SharedWidgets.js.map